angular.module('rjmNg.directives').directive "connectionList", [
  () ->
    restrict: "E"
    templateUrl: "directive.connectionList.html"
    replace: true
    scope: {
      addConnectionsUrl: "="
      isImplemented: "="
      isDisabledIntegrationsUi: "="
    }
    controllerAs: "view"
    bindToController: true
    controller: [
      "$routeParams"
      "appRoute"
      "jobService"
      "jobTypes"
      "logger"
      "ConnectionMeta"
      "$q"
      "notification"
      "Jobs"
      "JOBS"
      "connectionStatusTranslator"
      "CONNECTIONS"
      "Webhooks"
      "app"
      "InputConnections"
      "connectionUtils"
      "cloudbiConnectionUtils"
      "$route"
      (
        $routeParams
        appRoute
        jobService
        jobTypes
        logger
        ConnectionMeta
        $q
        notification
        Jobs
        JOBS
        connectionStatusTranslator
        CONNECTIONS
        Webhooks
        app
        InputConnections
        connectionUtils
        cloudbiConnectionUtils
        $route
      ) ->

        view = @

        view.nameFilter = ""

        view.showDeleteModal = false
        view.dependencies = null
        view.connectionList = []
        view.allowDeletion = app.isSupportUserSession()
        view.currentDependentConnection = null
        view.STATUS = connectionStatusTranslator.SIMPLIFIED_STATUS
        view.CONNECTION_STATUS = CONNECTIONS.STATUS


        view.webhooksModalHeader = null
        view.webhooksModalBody = null

        clientId = $routeParams.clientId
        WebhooksInstance = Webhooks(clientId)
        ConnectionMetaInstance = ConnectionMeta(clientId)
        InputConnectionsInstance = InputConnections(clientId)

        view.determinePausingPermission = (connection) ->
          isPausableIntegration = connection.type not in['google_analytics', 'google_analytics4_live', 'segment', 'push_api']
          (app.isSupportUserSession() or app.isAdminUser()) and isPausableIntegration

        formatConnectionName = (connection) ->
          name = connection.name
          # for OAuth2 GA connections we don't need to format
          if connection.type in ['google_analytics', 'google_analytics4_live'] and connection.properties.feature in ['analytics', 'analytics4live'] 
            return name
          return name?.replace(/Google Analytics:* /g, '')

        connectionIsDataSource = (connection) ->
          connection.type isnt CONNECTIONS.TYPES.USER_PUSH

        appendStatusToDBConnections = (connections) ->
          dbConnections = connections.filter connectionUtils.connectionIsDatabase

          dbStatusPromises = dbConnections.map (connection) ->
            deferred = $q.defer()
            ConnectionMetaInstance.status(connection.meta_id, false, false)
              .then deferred.resolve
              .catch deferred.reject
            return deferred.promise

          $q.all(dbStatusPromises).then (statuses) ->
            for status, index in statuses
              dbConnections[index].prettyStatus = connectionStatusTranslator.translateDBConnectorStatus(status)
          , (error) ->
            notification.error "Server Error", "An error occurred while attempting to retrieve integration status.", "all-connections"

        appendStatusToThirdPartyConnections = (connections) ->
          thirdPartyConnectionIds = _.chain connections
            .reject connectionUtils.connectionIsDatabase
            .pluck 'meta_id'
            .value()

          thirdPartyConnectionsByMetaId = {}

          apiStatusPromises = []

          for id in thirdPartyConnectionIds
            thirdPartyConnectionsByMetaId[id] = _.find connections, (connection) ->
              connection.meta_id is id

            apiDeferred = $q.defer()
            Jobs(clientId).getLast([id], JOBS.SOURCES.THIRD_PARTY)
              .then apiDeferred.resolve
              .catch apiDeferred.reject
            apiStatusPromises.push apiDeferred.promise

          $q.all(apiStatusPromises).then (statuses) ->
            for status, index in statuses
              statusResponse = _.values(status)[0]
              if statusResponse?
                thirdPartyConnectionsByMetaId[statusResponse.connection_id].prettyStatus = connectionStatusTranslator.translateThirdPartyConnectorStatus(statusResponse)
              else
                thirdPartyConnectionsByMetaId[thirdPartyConnectionIds[index]].prettyStatus =
                  status: view.STATUS.UNKNOWN
          , (err) ->
            notification.error "Server Error", "An error occurred while attempting to retrieve integration status.", "all-connections"

        showConnections = (allConnections) ->
          view.connectionList = allConnections.filter connectionIsDataSource
          for connection in view.connectionList
            connection.link = cloudbiConnectionUtils.getConnectionLink(connection)
            connection.name = formatConnectionName(connection)
            connection.encrypted = connection.properties.encryption_type isnt "none"

          appendStatusToDBConnections(view.connectionList)
          appendStatusToThirdPartyConnections(view.connectionList)

        queueConnectionDeleteJob = (clientId, connectionId) ->
          deferred = $q.defer()

          jobService(jobTypes.CONNECTION_DELETE).queue(
            {connectionId: connectionId}
            (result) -> deferred.resolve(result)
            (error) -> deferred.error(error)
          )

          deferred.promise

        view.deleteEndpoints = (connection) ->
          view.webhooksModalHeader = null
          view.webhooksModalBody = null
          webhookTypes = ['segment_webhooks']

          if connection.type in webhookTypes
            type = connection.type.replace(/_.*/, " ")
            WebhooksInstance.get().then (result) ->
              endpoints = result.filter (c) ->
                c.connection_id is connection.id

              $q.all(endpoints.map(WebhooksInstance.delete)).then (statuses) ->
                view.webhooksModalHeader = type.concat("Integration Successfully Deleted")
                view.webhooksModalBody = connection.type
                view.showWebhooksModal()
              , _onWebhookError
            , _onWebhookError

        _onWebhookError = (error) ->
          notification.clearAll()
          notification.error "Server Error", "There was an error when attempting to delete this integration. Please contact support.", "all-connections"

        view.forceDeleteConnection = (connection) ->
          view.gettingDependencies = true
          notification.info "Deleting Integration", "Deleting integration #{connection.name}. Please be patient.", "all-connections"

          queueConnectionDeleteJob(view.clientId, connection.meta_id).then (result) ->
            view.deleteEndpoints(connection)
            notification.clearAll()
            notification.success "Success!", "Successfully deleted integration #{connection.name}.", "all-connections", null, 10
            view.gettingDependencies = false
            view.showDeleteModal = false
            view.connectionList = _.without(view.connectionList, connection) # remove deleted connection from view.connectionList
          , (error) ->
            notification.clearAll()
            notification.error "Server Error", "There was an error when attempting to delete this integration. Please contact support.", "all-connections"

        view.deleteConnection = (connection) ->
          view.showDependenciesModal()
          view.gettingDependencies = true
          view.dependencies = null
          promise = ConnectionMetaInstance.getDependents(connection.meta_id)

          logger.log('Connections Page Usage', 'Delete', 1, 'edit')

          promise.then (result) ->
            if not _.isEmpty(result.data.dependents)
              view.dependencies = result.data.dependents
            view.currentDependentConnection = connection
            view.gettingDependencies = false

          , (error) ->
            view.hideDependenciesModal()
            notification.error "Server Error", error.data.message, "all-connections"

        InputConnectionsInstance.get(true)
          .then showConnections
          .catch (result) ->
            notification.clearAll()
            notification.error "Server Error", "There was an error when attempting to fetch your integrations. Please contact support.", "all-connections"

        view.pauseConnection = (connection) ->
          connectionObject = connection
          angular.extend connectionObject.properties,
            status: "3"

          InputConnectionsInstance.save(connectionObject)
          .then (response) ->
            $route.reload()
          .catch ({data}) ->
            notification.error "Server Error", "An error occurred while attempting to pause this integration.", "all-connections"

        view.startConnection = (connection) ->
          connectionObject = connection
          angular.extend connectionObject.properties,
            status: "1"

          InputConnectionsInstance.save(connectionObject)
          .then (response) ->
            $route.reload()
          .catch ({data}) ->
            notification.error "Server Error", "An error occurred while attempting to start this integration.", "all-connections"

        view.logButtonClick = (name) ->
          logger.log('Connections Page Usage', 'Open', 1, 'edit')

        view.confirmDelete = () ->
          view.hideDependenciesModal()
          view.forceDeleteConnection(view.currentDependentConnection)

        view.cancelDelete = () ->
          view.hideDependenciesModal()

        view.addConnectionUrl = appRoute("/settings/add-connection")

        view.showDependenciesModal = () ->
          $("#dependenciesModal").modal()
          return

        view.hideDependenciesModal = () ->
          $("#dependenciesModal").modal("hide")
          return

        view.showWebhooksModal = () ->
          $("#webhooksModal").modal()
          return

        view.hideWebhooksModal = () ->
          $("#webhooksModal").modal("hide")
          return

        view
    ]
]

